import React from 'react';
import { useSelector } from 'react-redux';
import { icons } from './Icons/Icons';

const ContactBlock = () => {
  const {
    title,
    description,
    contactInformationItems = [],
    buttonText,
    buttonLink,
    open,
  } = useSelector((state) => state.contactUs);

  const iconProps = {
    size: 48,
    color: '#9E8636',
  };

  function getParameterCaseInsensitive(object, key) {
    var x =
      object[
        Object.keys(object).filter(function (k) {
          return k.toLowerCase() === key.toLowerCase();
        })[0]
      ];
    return x.render(iconProps);
  }

  return (
    <div className="contact-us">
      <div className="contact-us__wrapper">
        <div className="contact-us__header">
          <h4>{title}</h4>
        </div>
        <ul className="contact-information__body">
          {contactInformationItems.map((item, index) => (
            <li key={item.title + '-key-' + index}>
              <a href={item.url}>
                {getParameterCaseInsensitive(icons, item.icon)}
                <div className="contact-information__body-text">
                  <strong>{item.title}</strong>
                  {item.subtitle}
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ContactBlock;
